import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
// import 'fast-text-encoding';
import React from 'react';
import ReactDOM from 'react-dom';
import 'moo-semantic-ui-css';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
);
